module.exports = __webpack_public_path__ + "img/media-hi.134cb2cd.png";